// Process @mentions
// Converts @user to a link with href "user"

import type StateInline from '../state-inline'

export default function mention(state: StateInline, silent: boolean): boolean {
  const start = state.pos
  const max = state.posMax

  // Check if we start with @
  if (state.src.charCodeAt(start) !== 0x40 /* @ */) return false

  // Must be preceded by whitespace or start of line
  if (start > 0) {
    const prev = state.src.charCodeAt(start - 1)
    // Allow @ after whitespace, punctuation, or at the start
    if (
      prev !== 0x20 /* space */ &&
      prev !== 0x09 /* tab */ &&
      prev !== 0x0a /* \n */ &&
      prev !== 0x0d /* \r */
    ) {
      return false
    }
  }

  const usernameStart = start + 1
  let pos = usernameStart

  // Parse username: alphanumeric, underscore, hyphen
  while (pos < max) {
    const code = state.src.charCodeAt(pos)
    if (
      (code >= 0x30 && code <= 0x39) || // 0-9
      (code >= 0x41 && code <= 0x5a) || // A-Z
      (code >= 0x61 && code <= 0x7a) || // a-z
      code === 0x5f || // _
      code === 0x2d // -
    ) {
      pos++
    } else {
      break
    }
  }

  const username = state.src.slice(usernameStart, pos)

  // Empty username or username starts with invalid character
  if (username.length === 0) return false

  if (!silent) {
    const token_open = state.push('mention_open', 'a', 1)
    token_open.attrs = [['href', username]]
    token_open.markup = '@'
    token_open.meta = { username }

    const token_text = state.push('text', '', 0)
    token_text.content = `@${username}`

    const token_close = state.push('mention_close', 'a', -1)
    token_close.markup = '@'
  }

  state.pos = pos
  return true
}
